import { ClientConfig } from "../ClientConfig";

const checkCookie = (name: string, value: string = 'true') => document.cookie.indexOf(`${name}=${value}`) !== -1;

class SynchedBreaksFeatureFlag {
    get isEnabled() {
        return ClientConfig.SYNCHED_BREAKS_ENABLED || checkCookie("synched-breaks-enabled");
    }
}

class TimedTournamentFeatureFlag {
    get isEnabled() {
        return ClientConfig.TIMED_TOURNAMENT_ENABLED || checkCookie("timed-tournament-enabled");
    }
}

class SpinHistoryFeatureFlag {
    get isEnabled() {
        return ClientConfig.SPIN_HISTORY_ENABLED || checkCookie("spin-history-enabled");
    }
}

class JSNGEntryFeatureFlag {
    get isEnabled() {
        return ClientConfig.JSNG_ENTRY_ENABLED || checkCookie("jsng-entry-enabled");
    }
}

class LeaderboardVisibilityFeatureFlag {
    get isEnabled() {
        return ClientConfig.LEADERBOARD_VISIBILITY_ENABLED || checkCookie("display-leaderboard-visibility");
    }
}

class RedeemableSweepsFeatureFlag {
    private isEnvironmentEnabled() {
        return ClientConfig.REDEEMABLE_SWEEPS.ENABLED || checkCookie("redeemable-sweeps-enabled");
    }
    isUserEnabled(pokUserId: number) {
        return this.isEnvironmentEnabled() && ClientConfig.REDEEMABLE_SWEEPS.POK_USER_IDS.indexOf(pokUserId) > -1;
    }
}

class AvatarMoveFeatureFlag {
    get isEnabled() {
        return ClientConfig.AVATAR_MOVE_ENABLED || checkCookie("avatar-move-enabled");
    }
}

class MysteryBountiesFeatureFlag {
    get isEnabled() {
        return ClientConfig.MYSTERY_BOUNTIES_ENABLED || checkCookie("mystery-bounties-enabled")
    }
}

class JsngEntryLiabilityFeatureFlag {
    get isEnabled() {
        return ClientConfig.JSNG_ENTRY_LIABILITY_ENABLED || checkCookie("jsng-entry-liability-enabled")
    }
}

export const FeatureToggleService = new class {
    synchedBreaksFeatureFlag = new SynchedBreaksFeatureFlag();
    timedTournamentFeatureFlag  = new TimedTournamentFeatureFlag();
    spinHistoryFeatureFlag = new SpinHistoryFeatureFlag();
    jsngEntryFeatureFlag = new JSNGEntryFeatureFlag();
    leaderboardVisibilityFeatureFlag = new LeaderboardVisibilityFeatureFlag();
    redeemableSweepsFeatureFlag = new RedeemableSweepsFeatureFlag()
    avatarMoveFeatureFlag = new AvatarMoveFeatureFlag();
    mysteryBountiesFeatureFlag = new MysteryBountiesFeatureFlag();
    jsngEntryLiabilityFeatureFlag = new JsngEntryLiabilityFeatureFlag();
}();



// WEBPACK FOOTER //
// ./src/app/service/FeatureToggleService.ts